import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { ITinVerificationWidgetStatusResponse } from "@modules/taxes/domain/infrastructure/taxes.remote";

@Component({
	selector: "tax-number-identification-banner",
	templateUrl: "./tax-number-identification-banner.html",
	styleUrls: ["./tax-number-identification-banner.scss", "./../taxes-banner/taxes-banner.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class TaxNumberIdentificationBannerComponent {
	data = input<Partial<ITinVerificationWidgetStatusResponse>>();
	onCTA = output<void>();

	public handleCTAClick(): void {
		this.onCTA.emit();
	}
}
